export default "__VITE_ASSET__Ddqa9LSl__"